<div class="simple-toast">
  <div class="toast-body">
    <div class="toast-text">
      <h4>{{ title }}</h4>
      <p>{{ message }}</p>
    </div>
    <div class="toast-actions">
      <button class="toast-btn" (click)="viewMore()">Ver más</button>
      <ion-icon name="close-outline" class="close-icon" (click)="closeToast()"></ion-icon>
    </div>
  </div>
</div>
